module.exports = __webpack_public_path__ + "static/img/two.ffe3058.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/9/two.png
// module id = tL8r
// module chunks = 1